import { Button, Modal, Menu, Avatar, TreeSelect } from 'antd'
import React, { useState, useEffect } from 'react'
import { use } from 'xadmin'
import _ from "lodash"


const SelectMenu = (props) => {
  const { form, menu, accordion } = use('form', state => ({ menu: state.values?.menu, accordion: state.values?.accordion }))

  const { input, input: { value } } = props
  let deep = _.cloneDeep(menu)
  const newmenu = fn(deep)
  function fn(arr) {
    for (let i = 0; i < arr?.length; i++) {
      let data = arr[i]
      if (!data.hasOwnProperty('children')) {
        let index = arr.findIndex((item) => item.key === data.key)
        arr.splice(index, 1)
        i--;
      } else {
         if (Array.isArray(data?.children) && data?.children.length > 0 ){
          fn(data.children)
         }
       
      }
    }
    return arr
  }


  const onChange = (newValue) => {
    input.onChange(newValue)
  };
  return (
    <TreeSelect
      showSearch
      style={{
        width: '100%',
      }}
      value={value || []}
      dropdownStyle={{
        maxHeight: 400,
        overflow: 'auto',
      }}
      placeholder="请选择"
      allowClear
      multiple={!accordion}
      treeDefaultExpandAll
      onChange={onChange}
      treeData={newmenu}
      fieldNames={{ label: 'title', value: 'key', children: 'children' }}
    />
  );
}
export default SelectMenu